module.exports = __webpack_public_path__ + "static/media/right-arrow-purple.97570b1a.svg";